export const statusColor = {
  PENDING: {
    background: "#FEF7EC",
    borderColor: "#FEF7EC",
    color: "#F3AF3D",
  },
  SUCCESS: {
    background: "#ECF8EC",
    borderColor: "#ECF8EC",
    color: "#3EBB3E",
  },
  FAIL: {
    background: "#FDEBED",
    borderColor: "#FDEBED",
    color: "#EF3948",
  },
  IN_PROGRESS: {
    background: "#E8F1F8",
    borderColor: "#E8F1F8",
    color: "#1576BC",
  },
  ACTIVE: {
    background: "#ECF8EC",
    borderColor: "#ECF8EC",
    color: "#3EBB3E",
  },
  INACTIVE: {
    background: "#FDEBED",
    borderColor: "#FDEBED",
    color: "#EF3948",
  },
  UNDEFINED: {
    background: "#F1F2F4",
    borderColor: "#F1F2F4",
    color: "#6A6A6A",
  },
};
